import React, { useCallback, useEffect, useRef, useState } from 'react';

import AntLocalization from '../../utils/AntLocalization';

export default function GoogleLoginButton({ onClick }) {
    return (
        <button
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '6px 18px',
                backgroundColor: 'white',
                border: '1px solid #DADCE0',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 500,
                boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#F7F8F8';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
            }}
        >
            {/* Google SVG Icon */}
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
                <path
                    fill="#EA4335"
                    d="M24 9.5c3.54 0 6.71 1.22 9.21 3.61l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.01 17.74 9.5 24 9.5z"
                />
                <path
                    fill="#4285F4"
                    d="M46.48 24.55c0-1.56-.14-3.06-.39-4.5H24v9h12.78c-.55 2.85-2.2 5.26-4.69 6.74l7.42 5.82C43.56 37.49 46.48 31.47 46.48 24.55z"
                />
                <path
                    fill="#FBBC05"
                    d="M10.54 28.41c-.48-1.45-.76-2.99-.76-4.58s.28-3.13.76-4.58l-7.98-6.19C1.4 16.3 0 20.04 0 24c0 3.96 1.4 7.7 3.56 10.94l7.98-6.19z"
                />
                <path
                    fill="#34A853"
                    d="M24 48c6.48 0 11.93-2.13 15.9-5.79l-7.42-5.82c-2.06 1.38-4.7 2.19-8.48 2.19-6.26 0-11.57-3.51-13.46-8.51l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                />
            </svg>

            <span>{AntLocalization.translateText({ vi: 'Đăng nhập với Google', en: 'Login with Google', fr: 'Se connecter avec Google', es: 'Iniciar sesión con Google', id: 'Masuk dengan Google', ja: 'Googleでログイン', zh: '使用Google登录', ko: 'Google로 로그인', hi: 'Google से लॉगिन', ar: 'تسجيل الدخول بـ Google' })}</span>
        </button>
    );
}
